// src/pages/feedback/FeedbackTicketDetailPage.js
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import FeedbackTicketDetail from '../../component/feedback/FeedbackTicketDetail';
import useFeedbackTicketDetail from '../../component/hooks/useFeedbackTicketDetail';
import { useAppSnackbar } from '../../component/providers/SnackbarProvider';

export default function FeedbackTicketDetailPage() {
  const { threadId } = useParams();
  const { showSnackbar } = useAppSnackbar();

  const {
    detail,
    loading,
    error,
    sending,
    sendMessage,
    refresh,
    loadMore,
    loadingMore,
    hasMore,
    updatingStatus,
    changeStatus,
  } = useFeedbackTicketDetail(threadId);

  const handleSend = useCallback(async (text) => {
    const res = await sendMessage(text);
    if (res?.ok) {
      showSnackbar('Yanıt gönderildi.', 'success');
    } else if (res?.message) {
      showSnackbar(res.message, 'error');
    }
    return res;
  }, [sendMessage, showSnackbar]);

  const handleStatusChange = useCallback(async (status) => {
    const res = await changeStatus(status);
    if (res?.ok) {
      showSnackbar('Durum güncellendi.', 'success');
    } else if (res?.message) {
      showSnackbar(res.message, 'error');
    }
    return res;
  }, [changeStatus, showSnackbar]);

  return (
    <FeedbackTicketDetail
      detail={detail}
      loading={loading}
      error={error}
      sending={sending}
      updatingStatus={updatingStatus}
      onSend={handleSend}
      onRefresh={refresh}
      onLoadMore={loadMore}
      hasMore={hasMore}
      loadingMore={loadingMore}
      onStatusChange={handleStatusChange}
    />
  );
}
